module.exports = __webpack_public_path__ + "img/game02.686e88df.png";